import { render, staticRenderFns } from "./DvoranaCreate.vue?vue&type=template&id=6bcfdce1&scoped=true&"
import script from "./DvoranaCreate.vue?vue&type=script&lang=js&"
export * from "./DvoranaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcfdce1",
  null
  
)

export default component.exports